import React, { useState, lazy, Suspense } from 'react';
import LockIcon from 'assets/svg/lock-icon';

const Modal = lazy(() => import('components/commons/modal'));

const LivenessExplanationModal: React.FC = (): JSX.Element => {
    const [visible, setVisible] = useState(false);

    return (
        <Suspense fallback="">
            <a
                href={void(0)}
                className="medium"
                onClick={() => setVisible(true)}
            >
                por que isso é necessário?
            </a>

            <Modal
                title="Por que isto é necessário?"
                visible={visible}
                onClose={() => setVisible(false)}
            >
                <p className="body-2">
                    A verificação de identificação nos ajuda a confirmar que você é quem afirma ser. Esta verificação é uma das maneiras que usamos para manter a Biz segura para os nossos clientes e protegê-los de possíveis fraudadores.
                </p>

                <p className="body-2 mb-5">
                    Através da nossa plataforma, você vai tirar uma foto de uma carteira de identidade (RG) ou carteira nacional de habilitação (CNH) e em seguida fazer uma foto sua de perfil (selfie). Compararemos esta nova foto com a foto presente no seu documento de identificação.
                </p>

                <h3 className="subtitle mb-3">
                    quais informações verificamos?
                </h3>

                <p className="body-2 mb-5">
                    Quando você envia um documento através da nossa ferramenta, nós conectamos as informações recebidas com diversos bancos de dados que verificam a veracidade do documeto e comparam se a pessoa que tirou a foto é a mesma do documento enviado.
                </p>

                <p className="d-flex body-2">
                    <span className="mr-3">
                        <LockIcon />
                    </span>
                    Seu documento de identificação está protegido e usamos apenas para confirmar a sua identidade.
                </p>
            </Modal>
        </Suspense>
    );
};

export default LivenessExplanationModal;
